import React from 'react';
import PropTypes from 'prop-types';
import './question-mark-icon.scss';

/* eslint-disable max-len */
const QuestionMarkIcon = ({ onClick, className }) => (
  // <svg onClick={ onClick } className='bb-question-mark-icon' viewBox="0 0 98.72 98.72"><path d="M50,.64A49.36,49.36,0,1,0,99.36,50,49.36,49.36,0,0,0,50,.64Zm-.24,83c-3.55,0-6.43-2.5-6.43-5.58s2.88-5.57,6.43-5.57S56.2,75,56.2,78.07,53.32,83.65,49.76,83.65ZM55.26,54v6.11a5.5,5.5,0,0,1-11,0v-11a5.49,5.49,0,0,1,5.49-5.5c6.35,0,11.71-3.72,11.71-8.12s-5.36-8.13-11.71-8.13-10.48,3.28-11.47,6.52a5.49,5.49,0,1,1-10.51-3.2c2.57-8.42,11.61-14.31,22-14.31,12.52,0,22.7,8.58,22.7,19.12C72.46,44.41,65.13,51.94,55.26,54Z" transform="translate(-0.64 -0.64)"/></svg>
  <svg
    onClick={ onClick }
    className={className ? 'bb-question-mark-icon ' + className : 'bb-question-mark-icon' }
    viewBox="0 0 55.364 98.111">
    <g>
      <path d="M49.654,10.3A28.381,28.381,0,0,0,22.287,1.717C11.825,4.107,3.938,11.9.648,23.1l13.891,4.079c1.8-6.114,5.692-10.147,10.972-11.353a13.888,13.888,0,0,1,13.4,4.178,9.474,9.474,0,0,1,2.563,7.635A15.1,15.1,0,0,1,34.965,37.86C21.783,47.249,19.583,52,19.993,60.689c.035.745.068,1.449.068,2.2V67.85H34.538V62.893c0-1.1-.045-2.047-.085-2.886-.109-2.316-.056-2.4.2-2.82.964-1.571,3.895-4.106,8.71-7.535a29.34,29.34,0,0,0,12.5-20.442A24.015,24.015,0,0,0,49.654,10.3Z" transform="translate(-0.648 -1)"/>
      <circle cx="27.524" cy="89.164" r="9.946" transform="translate(-55.635 44.578) rotate(-45)"/>
    </g>
  </svg>
);

QuestionMarkIcon.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default QuestionMarkIcon;
